<div class="flex flex-col gap-1 px-4 text-center">
  <div class="flex items-center">
    <h2 class="flex-1 text-xl text-gray-800">{{ welcomeTitle() }}</h2>
  </div>
  <p class="text-s text-center text-gray-400">{{ description() }}</p>
</div>

<ul class="flex flex-col gap-2 pt-4">
  <li>
    <button
      class="flex w-full gap-3 px-4 py-2 hover:bg-slate-100"
      type="button"
      (click)="onProviderClick('outlook')">
      <span class="block h-8 w-8">
        <img src="/assets/images/outlook.png" alt="Outlook" />
      </span>
      <div class="flex flex-col text-left">
        <span class="!text-left">Outlook</span>
        <span class="!text-xs !text-gray-400">outlook.com, live.com, hotmail.com</span>
      </div>
    </button>
  </li>
  <li>
    <button
      class="flex w-full gap-3 px-4 py-2 hover:bg-slate-100"
      type="button"
      (click)="onProviderClick('gmail_imap')">
      <span class="block h-8 w-8">
        <img src="/assets/images/gmail.png" alt="Gmail" />
      </span>
      <div class="flex flex-col text-left">
        <span class="!text-left">Gmail</span>
        <span class="!text-xs !text-gray-400">Login via IMAP</span>
      </div>
    </button>
  </li>
</ul>
